/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Star_AriaInputs */



/**
* | output |
* | --- |
* | "Star Record" |
*
* @param {Explorer_Info_Star_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_star_aria = /** @type {((inputs?: Explorer_Info_Star_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Star_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter aux favoris")
	if (locale === "de") return /** @type {LocalizedString} */ ("Star Record")
	if (locale === "it") return /** @type {LocalizedString} */ ("Record stellare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Star Record")
	if (locale === "es") return /** @type {LocalizedString} */ ("Récord estelar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("星录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スターレコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टार रिकॉर्ड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Recorde Estelar")
	return /** @type {LocalizedString} */ ("Star Record")
});